import { computed, Injectable, signal, Signal } from '@angular/core';
import { arraysEqual } from '@exl-ng/mulo-core';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    private _streamMap = signal(new Map<string, Signal<any[]>>(), {
        equal: (a, b) => {
            if (a?.size !== b?.size) return false;
            for (const [key, value] of a.entries()) {
                if (!b.has(key) || !arraysEqual(value(), b.get(key)())) {
                    return false;
                }
            }
            return true;
        },
    });
    streamMap = this._streamMap.asReadonly();
    streamKeys = computed(() => Array.from(this.streamMap().keys()));

    totalCount = computed(() => {
        let total = 0;
        this.streamMap().forEach((value) => {
            total += value().length;
        });
        return total;
    });

    constructor() {}

    addStream(typeKey: string, stream: Signal<any[]>) {
        if (!this._streamMap().has(typeKey)) {
            this._streamMap.update((map) => {
                map.set(typeKey, stream);
                return map;
            });
        }
    }
}
